import { getCoor } from "@/utils"

const { CameraMatics } = window

import { Logger } from "aws-amplify"
const logger = new Logger("Locations Helper Mixin")

export const locationsHelper = {
  methods: {
    findLocations (dataSet, props = {lat: 'lat', lng: 'lng'}, propetyName = "location", convert = false) {
      return new Promise(async (res, rej) => { 
        try {

          // first, check we have the names of the lat and lng properties on the object we are finding locations for
          if(!props.lat || !props.lng) {
            rej("no lat and lng property names were specified")
          }

          // first, we map our coord properties and prepare the array to be sent
          let coords = dataSet.map((i, index) => {
            i.arrayPos = index
            i.coords = convert  // if we need to convert from N/S to +/- we use the getCoor function from utils 
              ? { lat: getCoor(i[props.lat]), lng: getCoor(i[props.lng])}
              :  { lat: i[props.lat], lng: i[props.lng]}
            return i
          })

          // next we set up a map of the data; we use this later to directly assign the location API responses without any searching
          let responseLocations = coords.reduce((set, item) => {
            item[propetyName] = "Not known"
            set[item.arrayPos] = item
            return set
          }, {})

          // Split coords into arrays of no more than 100
          let setSize = 100
          let coordSets = []
          for (let i = 0; i < coords.length; i += setSize) {
            coordSets.push(coords.slice(i, i + setSize))
          }

          // we want no run all of these requests async so we map each request to a promise
          const promises = coordSets.map((i, setNumber) => new Promise(async (res) => {
            try {
              const location = await CameraMatics.HereMapService.multiRevGeocode(i)
              // if we can find the location
              if(location.Response) {
                let setNumberStart = setNumber 
                  ? setSize * setNumber
                  : 0

                location.Response.Item.forEach(locationResponse => {
                  responseLocations[Number.parseInt(locationResponse.ItemId) + setNumberStart][propetyName] = locationResponse.Result[0].Location.Address.Label
                })
              } 

              res(true)
            // if something goes wrong, we just set the location as not known!
            } catch (exception) {
              logger.debug("error getting locations", exception)
              res(true)
            }
          }))

          // wait for all requests to finish the return the ammended set
          await Promise.all(promises)

          logger.debug("coords 5", responseLocations)

          res(Object.values(responseLocations))

        } catch (ex) {
          logger.debug("error finding locations", ex)
          res(false)
        }
      })
    }
  }
};